<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useContextStore } from "@/store/context";

const { trackPage } = useTrackingPage();
const { layout } = storeToRefs(useContextStore());
const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[`/components/pages/creation-compte/${layout.value}.vue`]
  );
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.creationCompte);
});

definePageMeta({
  middleware: "inscription"
});
</script>

<template>
  <component
    :is="component"
    :from-path="$router.options.history.state.back"
  />
</template> 
